if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

       if (
  theme.settings.afterAtc !== 'no-js'
  || this.dataset.personalisationBlockId
) {
  this.form.addEventListener('submit', this.handleSubmit.bind(this));
}

if (this.dataset.personalisationBlockId) {
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => this.initGravurConfirmation(),
      { once: true }
    );
  } else {
    this.initGravurConfirmation();
  }
}

      }
    }

    generateBundleId() {
      return `ps-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    }

getPersonalisationModal() {
  const blockId = this.dataset.personalisationBlockId;

  if (blockId) {
    const dialog = document.getElementById(
      `modal-personalisation-${blockId}`
    );

    return dialog
      ? dialog.querySelector('.personalisation-modal')
      : null;
  }

  // Bestehendes Verhalten für andere Produktbereiche beibehalten.
  const scope = this.closest('section') || document;

  return scope.querySelector('.personalisation-modal')
    || document.querySelector(
      'body > modal-dialog .personalisation-modal'
    );
}


getGravurState() {
  if (!this.dataset.personalisationBlockId) return null;

  const modal = this.getPersonalisationModal();
  if (!modal) return null;

  const fields = Array.from(
    modal.querySelectorAll('input[name], select[name], textarea[name]')
  ).filter((field) =>
    field.name.startsWith('properties[')
    && !field.name.startsWith('properties[_preview_image_')
  );

  const value = (name) =>
    (modal.querySelector(`[name="properties[${name}]"]`)?.value || '').trim();

  const hasEmblem = (text) =>
    !!text
    && !text.includes('No emblems available')
    && !text.includes('Kein Emblem');

  const selected = ['front', 'back'].some((side) =>
    !!value(`text_${side}`)
    || hasEmblem(value(`emblem_${side}_link`))
  );

  return {
    selected,
    fingerprint: JSON.stringify(
      fields.map((field) => [field.name, field.value])
    )
  };
}

initGravurConfirmation() {
  if (this.gravurConfirmation) return;

  const blockId = this.dataset.personalisationBlockId;
  const wrapper = document.getElementById(`gravur-confirmation-${blockId}`);
  const checkbox = wrapper?.querySelector('input[type="checkbox"]');
  if (!wrapper || !checkbox) return;

  this.gravurConfirmation = {
    wrapper,
    checkbox,
    error: wrapper.querySelector('[role="alert"]'),
    confirmedFingerprint: null,
    lastFingerprint: null
  };

  const sync = () => {
    const state = this.getGravurState();
    const confirmation = this.gravurConfirmation;

    if (
      !state
      || state.fingerprint !== confirmation.lastFingerprint
      || !state.selected
    ) {
      checkbox.checked = false;
      confirmation.confirmedFingerprint = null;
    }

    confirmation.lastFingerprint = state?.fingerprint || null;
    wrapper.hidden = !state?.selected;

    confirmation.wrapper.classList.remove('is-invalid');
    confirmation.checkbox.removeAttribute('aria-invalid');


    // Dieser Kaufweg würde die eigene Warenkorb-Prüfung umgehen.
    this.querySelectorAll(
      '.product-info__dynamic-checkout-button'
    ).forEach((buttonWrapper) => {
      if (state?.selected) {
        if (!buttonWrapper.hasAttribute('data-gravur-original-style')) {
          buttonWrapper.setAttribute(
            'data-gravur-original-style',
            buttonWrapper.getAttribute('style') || ''
          );
        }
        buttonWrapper.style.setProperty('display', 'none', 'important');
      } else if (buttonWrapper.hasAttribute('data-gravur-original-style')) {
        const original = buttonWrapper.getAttribute(
          'data-gravur-original-style'
        );
        if (original) buttonWrapper.setAttribute('style', original);
        else buttonWrapper.removeAttribute('style');
        buttonWrapper.removeAttribute('data-gravur-original-style');
      }
    });
  };

  checkbox.checked = false;

  checkbox.addEventListener('change', () => {
    const state = this.getGravurState();
    this.gravurConfirmation.confirmedFingerprint =
      checkbox.checked && state?.selected ? state.fingerprint : null;

      this.gravurConfirmation.wrapper.classList.remove('is-invalid');
      checkbox.removeAttribute('aria-invalid');
      this.setErrorMsgState();


  });

  const handleEdit = (event) => {
    const modal = this.getPersonalisationModal();
    if (!modal || !modal.contains(event.target)) return;

    // Jeder Bearbeitungsschritt hebt die Bestätigung auf.
    checkbox.checked = false;
    this.gravurConfirmation.confirmedFingerprint = null;
    queueMicrotask(sync);
  };

  document.addEventListener('input', handleEdit);
  document.addEventListener('change', handleEdit);
  document.addEventListener('personalisation:emblem-change', handleEdit);
  document.addEventListener('personalisation:recalc', () => {
    queueMicrotask(sync);
  });

  window.addEventListener('pageshow', () => {
    checkbox.checked = false;
    this.gravurConfirmation.confirmedFingerprint = null;
    sync();
  });

  sync();
}

validateGravurConfirmation() {
  if (!this.dataset.personalisationBlockId) return true;
  const translationElement = document.getElementById(
  `gravur-confirmation-${this.dataset.personalisationBlockId}`
);


  const state = this.getGravurState();

  // Bei fehlender Zuordnung nicht unbemerkt weitermachen.
  if (!state) {
    this.setErrorMsgState(
      translationElement?.dataset.verificationError
      || 'Die Personalisierung konnte nicht geprüft werden. Bitte lade die Seite neu.'
    );

    return false;
  }

  if (!state.selected) return true;

  const confirmation = this.gravurConfirmation;
  const valid = confirmation?.checkbox.checked
    && confirmation.confirmedFingerprint === state.fingerprint;

  if (valid) return true;

  if (confirmation) {
    confirmation.checkbox.checked = false;
    confirmation.confirmedFingerprint = null;
    confirmation.wrapper.hidden = false;
    confirmation.wrapper.classList.add('is-invalid');
    confirmation.checkbox.setAttribute('aria-invalid', 'true'); 


    confirmation.wrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    confirmation.checkbox.focus({ preventScroll: true });
  }

this.setErrorMsgState(
  translationElement?.dataset.confirmationError
  || 'Bitte bestätige zuerst die aktuelle Gravurvorschau und die Hinweise.'
);

  return false;
}



    collectPersonalisationUpsells(bundleId, quantity) {
      const modal = this.getPersonalisationModal();
      if (!modal) return [];

      // Add-ons must match the number of knives added, so each add-on line uses the
      // same quantity as the main product (default 1).
      const upsellQuantity = Math.max(1, parseInt(quantity, 10) || 1);

      const isEmblemSelected = (value) => {
        if (!value) return false;
        const trimmed = value.trim();
        if (!trimmed) return false;
        return !trimmed.includes('No emblems available') && !trimmed.includes('Kein Emblem');
      };

      const textFront = modal.querySelector('input[name="properties[text_front]"]')?.value?.trim();
      const textBack = modal.querySelector('input[name="properties[text_back]"]')?.value?.trim();
      const textCount = (textFront ? 1 : 0) + (textBack ? 1 : 0);
      const textVariantId = Number(modal.dataset.textVariantId || 0);

      const emblemFront = modal.querySelector('input[name="properties[emblem_front_link]"]')?.value;
      const emblemBack = modal.querySelector('input[name="properties[emblem_back_link]"]')?.value;
      const emblemCount = (isEmblemSelected(emblemFront) ? 1 : 0) + (isEmblemSelected(emblemBack) ? 1 : 0);
      const emblemVariantId = Number(modal.dataset.emblemVariantId || 0);

      const items = [];
      const fontSelectFront = modal.querySelector('select[name="properties[text_front_font_family]"]');
      const fontSelectBack = modal.querySelector('select[name="properties[text_back_font_family]"]') || modal.querySelector('select[name="properties[text_front_font_family]"]');
      const sides = ['front', 'back'];

      sides.forEach((side) => {
        const textValue = (modal.querySelector(`input[name="properties[text_${side}]"]`)?.value || '').trim();
        const emblemLink = (modal.querySelector(`input[name="properties[emblem_${side}_link]"]`)?.value || '').trim();

        const textPresent = !!textValue;
        const emblemPresent = isEmblemSelected(emblemLink);

        if (textPresent && textVariantId) {
          const fontSelect = side === 'front' ? fontSelectFront : fontSelectBack;
          const fontFamily =
            fontSelect?.options?.[fontSelect.selectedIndex || 0]?.value ||
            fontSelect?.value ||
            '';
          // Position/size are shared as normalized, rounded px (data-share-px), set by
          // personalisation.js against the preview's original image width. Rotation
          // stays in degrees (scale-invariant).
          const fontSizePx = modal.querySelector(`input[name="properties[font_size_${side}]"]`)?.dataset.sharePx || '';
          const rotation = modal.querySelector(`input[name="properties[font_rotation_${side}]"]`)?.value || '';
          const xPosPx = modal.querySelector(`input[name="properties[x_position_${side}]"]`)?.dataset.sharePx || '';
          const yPosPx = modal.querySelector(`input[name="properties[y_position_${side}]"]`)?.dataset.sharePx || '';

          items.push({
            id: textVariantId,
            quantity: upsellQuantity,
            properties: {
              _bundle_id: bundleId,
              _bundle_role: 'addon',
              _bundle_type: 'text',
              side,
              text: textValue,
              font_family: fontFamily,
              font_size: fontSizePx ? `${fontSizePx} px` : '',
              font_rotation: rotation ? `${Math.round(Number(rotation))} deg` : '',
              x_position: xPosPx ? `${xPosPx} px` : '',
              y_position: yPosPx ? `${yPosPx} px` : ''
            }
          });
        }

        if (emblemPresent && emblemVariantId) {
          // emblem_size = rendered width (px); emblem_height = rendered height (px);
          // positions in px. All normalized to the preview's original image width.
          const emblemSizeInput = modal.querySelector(`input[name="properties[emblem_size_${side}]"]`);
          const emblemWidthPx = emblemSizeInput?.dataset.sharePx || '';
          const emblemHeightPx = emblemSizeInput?.dataset.shareHeightPx || '';
          const xPosEmblemPx = modal.querySelector(`input[name="properties[x_position_emblem_${side}]"]`)?.dataset.sharePx || '';
          const yPosEmblemPx = modal.querySelector(`input[name="properties[y_position_emblem_${side}]"]`)?.dataset.sharePx || '';
          const emblemName = modal.querySelector(`select[name="properties[emblem_${side}]"]`)?.value || '';
          const emblemFile = modal.querySelector(`input[name="properties[emblem_${side}_file_name]"]`)?.value || '';

          items.push({
            id: emblemVariantId,
            quantity: upsellQuantity,
            properties: {
              _bundle_id: bundleId,
              _bundle_role: 'addon',
              _bundle_type: 'emblem',
              side,
              emblem: emblemName,
              emblem_link: emblemLink,
              emblem_file_name: emblemFile,
              emblem_size: emblemWidthPx ? `${emblemWidthPx} px` : '',
              emblem_height: emblemHeightPx ? `${emblemHeightPx} px` : '',
              x_position: xPosEmblemPx ? `${xPosEmblemPx} px` : '',
              y_position: yPosEmblemPx ? `${yPosEmblemPx} px` : ''
            }
          });
        }
      });

      return items;
    }

    appendPersonalisationProperties(formData, bundleId) {
      const modal = this.getPersonalisationModal();
      if (!modal) return false;

      const getValue = (selector) => {
        const el = modal.querySelector(selector);
        return el ? el.value || '' : '';
      };

      const appendProp = (key, value) => {
        if (value === null || value === undefined) return;
        const stringValue = String(value);
        if (!stringValue.trim()) return;
        formData.append(`properties[${key}]`, stringValue);
      };
      const appendPropWithUnit = (key, value, unit) => {
        const num = Number.parseFloat(value);
        if (!Number.isFinite(num)) return;
        appendProp(key, `${num}${unit ? ` ${unit}` : ''}`);
      };

      const hasEmblem = (value) => {
        if (!value) return false;
        const trimmed = value.trim();
        if (!trimmed) return false;
        return !trimmed.includes('No emblems available') && !trimmed.includes('Kein Emblem');
      };

      const findFontSelectForSide = (side) => {
        const candidates = modal.querySelectorAll('select[name="properties[text_front_font_family]"]');
        if (!candidates.length) return null;
        return Array.from(candidates).find((el) => el.closest(`.${side}`)) || candidates[0] || null;
      };

      const sides = ['front', 'back'];

      let hasPersonalisation = false;

      sides.forEach((side) => {
        const textValue = getValue(`input[name="properties[text_${side}]"]`).trim();
        const emblemLinkValue = getValue(`input[name="properties[emblem_${side}_link]"]`).trim();
        const textPresent = !!textValue;
        const emblemPresent = hasEmblem(emblemLinkValue);
        if (textPresent || emblemPresent) {
          hasPersonalisation = true;
        }
      });

      if (hasPersonalisation && bundleId) {
        appendProp('_bundle_id', bundleId);
        appendProp('_bundle_role', 'main');
        appendProp('_preview_image_front', getValue('input[name="properties[_preview_image_front]"]'));
        appendProp('_preview_image_back', getValue('input[name="properties[_preview_image_back]"]'));
      }

      return hasPersonalisation;
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      if (!this.validateGravurConfirmation()) return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      const bundleId = this.generateBundleId();

      // The Cloudinary preview normally uploads when the modal's Save button is
      // clicked, but the customer can close the modal without saving and the
      // upload itself can fail silently. Last chance to capture it is now,
      // while the modal DOM is still on the page.
      try {
        const personalisationModal = this.getPersonalisationModal();
        if (personalisationModal && typeof personalisationModal.ensurePreviewImages === 'function') {
          // Cap the wait so a stalled capture/upload can never leave the
          // add-to-cart button stuck in its loading state.
          await Promise.race([
            personalisationModal.ensurePreviewImages(),
            new Promise((resolve) => { setTimeout(resolve, 10000); })
          ]);
        }
      } catch (error) {
        // Never block add-to-cart on the preview; the order simply won't
        // carry a _preview_image property, as before.
      }

      const hasPersonalisation = this.appendPersonalisationProperties(formData, bundleId);
if (hasPersonalisation && this.dataset.personalisationBlockId) {
  formData.set(
    'properties[Gravurfreigabe]',
    'Gravurvorschau, Personalisierung und Hinweise zum Widerrufsrecht bestätigt'
  );
}

      const personalisationItems = hasPersonalisation
        ? this.collectPersonalisationUpsells(bundleId, formData.get('quantity'))
        : [];

      formData.append('sections_url', window.location.pathname);
      // When add-on items follow in a second call, only that final call requests the
      // rendered sections: the drawer (and the packaging selection it contains) must
      // reflect the complete cart, never the intermediate knife-only state.
      if (!personalisationItems.length) {
        formData.append('sections', sections);
      }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();
// Erneut prüfen, weil zuvor Vorschau-Uploads und andere
// asynchrone Schritte gelaufen sein können.
if (!this.validateGravurConfirmation()) {
  throw new Error('Gravurfreigabe fehlt oder wurde ungültig.');
}

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        let data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (personalisationItems.length) {
          const extraBody = JSON.stringify({
            items: personalisationItems,
            sections,
            sections_url: window.location.pathname
          });
          const extraResponse = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json'
            },
            body: extraBody
          });
          const extraData = await extraResponse.json();
          if (extraResponse.ok) {
            data = extraData;
          } else {
            let extraError = typeof extraData.description === 'string' ? extraData.description : extraData.message;
            if (extraData.errors && typeof extraData.errors === 'object') {
              extraError = Object.entries(extraData.errors).map((item) => item[1].join(', '));
            }
            this.setErrorMsgState(extraError);
            throw new Error(extraResponse.status);
          }
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
